module.exports = __webpack_public_path__ + "img/汽车滑轨1.5d841e03.jpg";